import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files - German translations, English provided by keys
import deCommon from "../../locales/de.json";
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_COOKIE,
  toSupportedLanguage,
  getLanguageFromCookie,
  setLanguageCookie,
} from "@/app/utils/language";

// Re-export the language helpers so existing importers of this module keep
// working; the implementations live in the framework-agnostic ./language module
// (which the server can import without pulling in react-i18next).
export {
  DEFAULT_LANGUAGE,
  LANGUAGE_COOKIE,
  toSupportedLanguage,
  getLanguageFromCookie,
  setLanguageCookie,
};

const resources = {
  de: {
    common: deCommon,
  },
  en: {
    common: {}, // Empty object - keys will serve as English text
  },
};

export const languageList = [
  {
    language: "English",
    abbr: "EN",
    value: "en",
  },
  {
    language: "Deutsch",
    abbr: "DE",
    value: "de",
  },
];

const i18n = createInstance();

i18n.use(initReactI18next).init({
  resources,
  // Initialize in the cookie's language. On the server there is no document, so
  // this resolves to the default; entry.server.tsx renders each request with a
  // per-request instance set to that request's cookie language. The language is
  // set HERE, before the first render — applying it in a post-hydration effect
  // does not re-render already-hydrated text, so a refresh always reverted.
  lng: getLanguageFromCookie(
    typeof document !== "undefined" ? document.cookie : null
  ),
  fallbackLng: DEFAULT_LANGUAGE, // English keys when a German translation is missing
  debug: false, // Disable debug mode to remove missingKey logs
  // Keys are natural-language English sentences, so "." and ":" inside them
  // are punctuation, not nesting or namespace separators.
  keySeparator: false,
  nsSeparator: false,

  interpolation: {
    escapeValue: false, // React already escapes values
  },

  defaultNS: "common",
  ns: ["common"],
});

export default i18n;
